import { render, staticRenderFns } from "./PharmacyRecord.vue?vue&type=template&id=6ba3371b&scoped=true"
import script from "./PharmacyRecord.vue?vue&type=script&lang=js"
export * from "./PharmacyRecord.vue?vue&type=script&lang=js"
import style0 from "./PharmacyRecord.vue?vue&type=style&index=0&id=6ba3371b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba3371b",
  null
  
)

export default component.exports